export const modals = state => state.modal.modals;
